import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { Process } from "@/components/Process";
import { Customers } from "@/components/Customers";
import { DataCapture } from "@/components/DataCapture";
import { RemoteTeam } from "@/components/RemoteTeam";
import { Collaborate } from "@/components/Collaborate";
import { Solutions } from "@/components/Solutions";
import { Support } from "@/components/Support";
import HowItWorks from "@/components/HowItWorks";
import { Industries } from "@/components/Industries";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const Index = () => {
  const dataCapture = useScrollAnimation();
  const remoteTeam = useScrollAnimation();
  const collaborate = useScrollAnimation();
  const solutions = useScrollAnimation();
  const industries = useScrollAnimation();
  const support = useScrollAnimation();
  const howItWorks = useScrollAnimation();
  const process = useScrollAnimation();

  return (
    <div className="min-h-screen">
      <Hero />
      <Features />
      {/* Fade in from right */}
      <div
        ref={dataCapture.elementRef}
        className={`transform transition-all duration-700 ${
          dataCapture.isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"
        }`}
      >
        <DataCapture />
      </div>
      {/* Scale and fade */}
      <div
        ref={remoteTeam.elementRef}
        className={`transform transition-all duration-700 ${
          remoteTeam.isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
      >
        <RemoteTeam />
      </div>
      {/* Fade in from left */}
      <div
        ref={collaborate.elementRef}
        className={`transform transition-all duration-700 ${
          collaborate.isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-20"
        }`}
      >
        <Collaborate />
      </div>
      {/* Fade up with scale */}
      <div
        ref={solutions.elementRef}
        className={`transform transition-all duration-700 ${
          solutions.isVisible 
            ? "opacity-100 translate-y-0 scale-100" 
            : "opacity-0 translate-y-10 scale-95"
        }`}
      >
        <Solutions />
      </div>
      {/* Fade down */}
      <div
        ref={industries.elementRef}
        className={`transform transition-all duration-700 ${
          industries.isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-10"
        }`}
      >
        <Industries />
      </div>
      {/* Rotate and fade */}
      <div
        ref={support.elementRef}
        className={`transform transition-all duration-700 ${
          support.isVisible ? "opacity-100 rotate-0" : "opacity-0 rotate-2"
        }`}
      >
        <Support />
      </div>
      {/* Fade in from right with scale */}
      <div
        ref={howItWorks.elementRef}
        className={`transform transition-all duration-700 ${
          howItWorks.isVisible 
            ? "opacity-100 translate-x-0 scale-100" 
            : "opacity-0 translate-x-20 scale-95"
        }`}
      >
        <HowItWorks />
      </div>
      {/* Zoom and fade */}
      <div
        ref={process.elementRef}
        className={`transform transition-all duration-700 ${
          process.isVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"
        }`}
      >
        <Process />
      </div>
      {/* Keeping the import but commenting out the component for future use */}
      {/* <Customers /> */}
    </div>
  );
};

export default Index;
